import './TEventList.scss';
import Control from "../../1. Core/Control";
import NP, {EventArgs, ValueChangedEventArgs} from "../../1. Core/NP";
import TopAppBar from "../../1. Core/Controls/TopAppBar/TopAppBar";
import Delegate from "../../1. Core/Delegate";
import {ServerAPI} from "../../1. Core/ServerAPI";
import DataTable from "../../1. Core/Controls/DataTable/DataTable";


import IconToggleButton from "../../1. Core/Controls/IconToggleButton/IconToggleButton";
import {EventTournament, getSportType, PageMode, SportType} from "../types";
import TEventListFilterPanel from "../Library/Panels/TEventListFilterPanel";
import Menu from "../../1. Core/Controls/Menu/Menu";
import ListItem from "../../1. Core/Controls/ListBox/ListItem";
import TEventDialog from "./TEventDialog";
import {downloadVideoFile} from "../Util";
import {getCurrentUser} from "../../1. Core/UserInfo";
import DrillEventPanel from "./DrillEventPanel";
import HLStatDialog from "./HLStatDialog";
import EventStatWidgetEditDialog from "../WidgetManager/EventStatWidgetEditDialog/EventStatWidgetEditDialog";
import Dialog, {DialogCloseEventArgs} from "../../1. Core/Controls/Dialog/Dialog";
import TextField from "../../1. Core/Controls/TextField/TextField";

let moment = require('moment');


export default class TEventList extends Control {
	private _Count: number;
	private _Offset: number;
	private _DrillDownMode: boolean;
	private _topAppBar: TopAppBar;
	private _FilterText: string;
	private EvShowPageModeClick: Delegate;
	private EvPageModeChanged: Delegate;

	private _dataTable: DataTable;
	private _filtersPanel: TEventListFilterPanel;
	private _drillDownPanel: DrillEventPanel;

	private _statesListNode: HTMLElement;
	private _dataWithFiltersNode: HTMLElement;
	private _AllCount: number;
	private _Mode: PageMode;
	private _OpenedItemId: number;


	constructor(settings: object)
	{
		super(settings);
		this._render();
	}

	_initFields(settings: object)
	{
		this._Mode = null;
		this._DrillDownMode = false;
		this.EvShowPageModeClick = new Delegate();
		this.EvPageModeChanged = new Delegate();
		this._FilterText = '';
		this._OpenedItemId = null;
		super._initFields(settings);
	}

	_render()
	{
		this.np_render();

		this._Count = 100;
		this._Offset = 0;

		this._statesListNode = NP.createNode(this._root);

		this._topAppBar = new TopAppBar({
			Class: 'top-app-bar--no-shadow top-app-bar--light library-box-list__app-bar',
			Caption: NP.RM.getString('Events'),
			ParentNode: this._statesListNode,
			EvSearch: (s: Control, e: ValueChangedEventArgs) =>
			{
				this._FilterText = e.Value;
				this._Offset = 0;
				this._refreshList();
			},
			EvHideSearch: () =>
			{
				this._Offset = 0;
				this._FilterText = null;
				this._refreshList();
			},
			ShowSearchButton: true,
			MainButton: {
				FontImage: NP.FontImages.menu,
				EvClick: () => this.EvShowPageModeClick.fire(this)
			},
			EvFocusSearch: () =>
			{
			}
		});

		if (this._Mode != PageMode.bookmaker && this._Mode != PageMode.mmahighlights && this._Mode != PageMode.kbhighlights && getCurrentUser().isBDAdmin())
			this._topAppBar.addItem(new IconToggleButton({
				FontImage: NP.FontImages.add,
				Tooltip: NP.RM.getString('Create'),
				EvClick: () =>
				{
					new TEventDialog({
						Type: getSportType(this._Mode),
						EvOkButtonClick: () => this._refreshList()
					}).show();
				}
			}));

		this._topAppBar.addItem(new IconToggleButton({
			FontImage: NP.FontImages.tune,
			Value: 'Filters',
			EvClick: (btn: IconToggleButton) =>
			{
				btn.setData(!btn.getData())
				this._filtersPanel.setIsVisible(!this._filtersPanel.getIsVisible());
				this.setWidth(this._Width);
			}
		}));

		this._dataWithFiltersNode = NP.createNode(this._statesListNode, 'data-with-filters-container');

		let ishl = this._Mode == PageMode.mmahighlights || this._Mode == PageMode.kbhighlights

		this._dataTable = new DataTable({
			ParentNode: this._dataWithFiltersNode,
			Class: 'app-list--avatars mdc-data-table--margin data-table-battle',
			CustomSettingsButtonCreated: (ctrl: IconToggleButton, index: number) =>
			{
				let ev = ctrl.getData() as EventTournament
				switch (index)
				{
					case 0:
						if (!ev.HLUrl_Full)
							ctrl.setEnabled(false)
						break;
					case 1:
						if (!ev.HLUrl_Optimal)
							ctrl.setEnabled(false)
						break;
					case 2:
						if (!ev.HLUrl_Short)
							ctrl.setEnabled(false)
						break;
				}
			},
			ShowSettingsButton: this._Mode != PageMode.bookmaker && !ishl,
			HeaderPaddingRight: ishl ? '27px' : '',
			CustomSettingsHeader: ishl ? 'Event &nbsp; &nbsp;  Maincard &nbsp;  Prelims' : '',
			CustomSettingsButton: ishl ? [{
				FontImage: NP.FontImages.download,
				ToolTip: 'Event',
				EvClick: (s: Control, e: EventArgs) =>
				{
					e.Event.preventDefault()
					e.Event.stopPropagation();

					let ev = (s.getData() as EventTournament);
					downloadVideoFile(ev.HLUrl_Full, ev.Name, 'full')
				}
			}, {
				FontImage: NP.FontImages.download,
				ToolTip: 'Maincard',
				EvClick: (s: Control, e: EventArgs) =>
				{
					e.Event.preventDefault()
					e.Event.stopPropagation();

					let ev = (s.getData() as EventTournament);
					downloadVideoFile(ev.HLUrl_Optimal, ev.Name, 'optimal')
				}
			}, {
				FontImage: NP.FontImages.download,
				ToolTip: 'Prelims',
				EvClick: (s: Control, e: EventArgs) =>
				{
					e.Event.preventDefault()
					e.Event.stopPropagation();
					let ev = (s.getData() as EventTournament);
					downloadVideoFile(ev.HLUrl_Short, ev.Name, 'short')

				}
			}] : null,
			MultiSelect: false,
			ShowRowIndex: true,
			ImageWidth: 32,
			Columns: [{
				Content: NP.RM.getString('Name'),
				PropertyContent: 'Name',
				Width: '25%'
			}, {
				Content: NP.RM.getString('Tournament'),
				PropertyContent: 'TournamentName',
				Width: '25%'
			}, {
				Content: NP.RM.getString('BattleCount'),
				PropertyContent: 'BattleCount',
				Width: '25%'
			}, {
				Content: NP.RM.getString('Date'),
				PropertyContent: 'DateStr',
				Width: '25%'
			}],
			ShowPaginator: true,
			EvSortClick: (s: DataTable, e: any) =>
			{
				e.CanceSort = true;

				switch (e.Column)
				{
					case 0:
						this._filtersPanel.setSortValues('Name', e.Direction);
						break;
					case 1:
						this._filtersPanel.setSortValues('TournamentName', e.Direction);
						this._refreshList();
						break;
					case 2:
						this._filtersPanel.setSortValues('BattleCount', e.Direction);
						this._refreshList();
						break;
					case 3:
						this._filtersPanel.setSortValues('Date', e.Direction);
						this._refreshList();
						break;
				}
			},
			EvPaginatorLeftClick: () =>
			{
				this._Offset -= this._Count;
				this._refreshList();
			},
			EvItemClick: (s: object, e: { Item: EventTournament }) =>
			{
				this.showBattleList(e.Item);
			},
			EvPaginatorRightClick: () =>
			{
				this._Offset += this._Count;
				this._refreshList();
			},
			EvItemContextMenu: async (s: any, e: { Event: any, Item: EventTournament }) =>
			{
				if (ishl)
					return;

				let user = getCurrentUser();

				let witems = this._Mode == PageMode.mmaevents && user.getIsAdmin() ? [
					{IsSeparator: true},
					{RK: 'Statistics', Value: 'Statistics'},
					{RK: 'StatisticsSimple', Value: 'StatisticsSimple'},
					{RK: 'StatisticsMaincard', Value: 'StatisticsMaincard'},
				] : [];
				let menu = new Menu({
					Items: [
						user.isBDAdmin() && {RK: 'Edit', Value: 'Edit'},
						e.Item.BattleCount == 0 && user.isBDAdmin() && {RK: 'Remove', Value: 'Remove'},
						user.isBDAdmin() && {Content: 'Stat', Value: 'Stat'},
						user.isBDAdmin() && {Content: 'Create Event Stat Widget', Value: 'Widget'},
						user.isBDAdmin() && {IsSeparator: true},
						user.getEmail() != 'karate combat' && {RK: 'ExportBattles', Value: 'ExportBattles'},
						user.getEmail() != 'karate combat' && {RK: 'ExportAthletes', Value: 'ExportAthletes'},
						{
							Content: 'Send notification',
							Value: 'PushOpenGame'
						},
						...witems
					],
					EvItemSelected: async (s: Menu, args: { Item: ListItem }) =>
					{
						let evT = e.Item as EventTournament;
						switch (args.Item.getValue())
						{
							case 'Remove':
								NP.showConfirm({
									RK: 'AreYouS',
									EvOkButtonClick: async () =>
									{
										await ServerAPI.delet(`/t-events/${evT.Id}`);
										this._dataTable.removeRow(e.Item)
									}
								}).show();
								break;
							case 'Widget':
								(new EventStatWidgetEditDialog({
									Event: evT
								})).show()
								break;
							case 'Stat':
								(new HLStatDialog({
									Event: evT
								})).show();
								break;
							case 'ExportBattles':
								NP.downloadFile(`/ui-api/mma/exportBattlesFromEvent/${evT.Id}`);
								break;
							case 'ExportAthletes':
								NP.downloadFile(`/ui-api/mma/exportAthletesFromEvent/${evT.Id}`);
								break;
							case 'Edit':
								(new TEventDialog({
									Event: e.Item as EventTournament,
									Type: getSportType(this._Mode),
									EvClosed: () => this._refreshList()
								})).show();
								break;
							case 'StatisticsSimple':
								window.open(`/mma-event-stat-bd?id=${e.Item.GloryEventID}&lang=${NP.getCurrentCulture().Name}`);
								break;
							case 'Statistics':
								window.open(`/mma-event-stat?id=${e.Item.GloryEventID}&lang=${NP.getCurrentCulture().Name}`);
								break;
							case 'StatisticsMaincard':
								window.open(`/mma-event-stat?id=${e.Item.GloryEventID}&lang=${NP.getCurrentCulture().Name}&stage=Maincard`);
								break;
							case 'PushOpenGame':
								new Dialog({
									Content: [
										new TextField({
											FloatingLabel: 'Title',
											Value: evT.Name
										}),
										new TextField({
											FloatingLabel: 'Body',
											Value: 'You still have time to make your prediction and pick fighters'
										})
									],
									EvOkButtonClick: (dlg: Dialog, args: DialogCloseEventArgs) =>
									{
										let c = dlg.getContent();
										ServerAPI.post(`/fantasy/sendNotification`, {
											type: 'OpenNewGame',
											eventId: evT.Id,
											body: {
												body: c[1].getValue(),
												title: c[0].getValue()
											}
										});
									}
								}).show()
								break;
						}
					}
				});
				menu.showContextMenu(e.Event);
			},
			EvSelectionChanged: () =>
			{
			},
			EvScrolled: (s: DataTable, e: any) => this._onScrolled(s, e)
		});


		this._filtersPanel = new TEventListFilterPanel({
			ParentNode: this._dataWithFiltersNode,
			Width: 280,
			SportType: this._Mode == PageMode.kbevents ? SportType.KB : SportType.MMA,
			EvFilterSortChanged: () => this._refreshList()
		});
	}

	showBattleList(event: EventTournament)
	{
		NP.updateBrowserUrlString(true, this._Mode, event.Id);

		this._DrillDownMode = true;
		NP.hideNode(this._statesListNode);

		let mode = PageMode.mmaevents;

		if (this._Mode == PageMode.kbevents)
			mode = PageMode.kbbouts;
		else if (this._Mode == PageMode.bookmaker)
			mode = PageMode.bookmaker;
		else if (this._Mode == PageMode.mmahighlights)
			mode = PageMode.mmahighlights;
		else if (this._Mode == PageMode.kbhighlights)
			mode = PageMode.kbhighlights;
		else if (this._Mode == PageMode.boxevents)
			mode = PageMode.boxevents;


		this._drillDownPanel = new DrillEventPanel({
			ParentNode: this._root,
			Width: this._Width,
			Event: event,
			Height: this._Height,
			Mode: mode,
			EvBackClick: () =>
			{
				NP.updateBrowserUrlString(true, this._Mode);
				this._OpenedItemId = null;
				this._DrillDownMode = false;
				NP.showNode(this._statesListNode);
				this._drillDownPanel.destroy();
				this._drillDownPanel = null;
				this._refreshList();
			}
		})
	}

	_onScrolled(s: DataTable, e: any)
	{
		if (e.scroll > 0 && e.isSmall)
			this._topAppBar.addClass('top-app-bar--fixed-scrolled');
		else
			this._topAppBar.removeClass('top-app-bar--fixed-scrolled');
	}

	async refresh()
	{
		if (this._OpenedItemId)
		{
			let ev = await ServerAPI.get<EventTournament>(`/t-events/${this._OpenedItemId}`)
			if (ev)
				this.showBattleList(ev);
		}
		else
		{
			this._refreshList();

			this._onScrolled(null, {
				scroll: 0,
				isSmall: this._dataTable.getIsSmall()
			});
		}
	}

	async _refreshList()
	{

		this._dataTable.setRows([]);

		let args = this._filtersPanel.getFilterData();

		let response = await ServerAPI.post("/t-events", {
			FilterText: this._FilterText,
			...args,
			Offset: this._Offset,
			Count: this._Count,
			SportType: getSportType(this._Mode),
			CalcCount: true
		}) as { List: EventTournament[], AllCount: number };


		if (response.AllCount)
			this._AllCount = response.AllCount;

		this._dataTable.setShowPaginator(this._AllCount > this._Count);
		this._dataTable.getRightPagButton().setEnabled(this._Offset + this._Count < this._AllCount);
		this._dataTable.updatePagCaption(`${this._Offset + 1} - ${Math.min(this._Offset + this._Count, this._AllCount)} ${NP.RM.getString("of")} ${this._AllCount}`);
		this._dataTable.getLeftPagButton().setEnabled(this._Offset > 0);

		let now = new Date();
		this._dataTable.setRows(response.List.map(ev =>
		{

			let row = {
				...ev,
				CssClass: ''
			}
			if (ev.Date)
			{
				let d = moment(ev.Date)
				row.DateStr = d.format(NP.getDayFormat() + " HH:mm")  + ' UTC'

				if (d.toDate().getTime() - now.getTime() > 0)
				{
					row.CssClass = 'new-event-row';
				}
			}
			return row;
		}));


		if (args)
			switch (args.SortField)
			{
				case 'Name':
					this._dataTable.updateSortIndicator(0, args.SortDirection);
					break;
				case 'TournamentName':
					this._dataTable.updateSortIndicator(1, args.SortDirection);
					break;
				case 'BattleCount':
					this._dataTable.updateSortIndicator(2, args.SortDirection);
					break;
				case 'Date':
					this._dataTable.updateSortIndicator(3, args.SortDirection);
					break;
			}
	}


	setHeight(value: number)
	{
		super.setHeight(value);
		let h = this._getContentHeight();
		this._dataTable.setHeight(h);
		this._filtersPanel.setHeight(h);

		if (this._drillDownPanel)
			this._drillDownPanel.setHeight(this.getHeight());
	}

	_getContentHeight()
	{
		return this._Height - this._topAppBar.getOffsetHeight();
	}

	setWidth(value: number)
	{
		super.setWidth(value);
		this._dataTable.setWidth(value);


		if (this._drillDownPanel)
			this._drillDownPanel.setWidth(this.getWidth());

		if (this._dataTable.getIsSmall())
		{
			this._topAppBar.removeClass('top-app-bar--no-shadow');
			this.setHeight(this._Height);
		}
		else
		{
			this._topAppBar.addClass('top-app-bar--no-shadow');
			this.setHeight(this._Height);
		}
	}

	getTopAppBar()
	{
		return this._topAppBar;
	}

	getDataTable()
	{
		return this._dataTable;
	}
}
